<div class="flex text-gray-500 py-3 text-sm font-medium transition-all cursor-pointer border-b border-b-transparent" [relativeTo]="route" [routerLink]="link" routerLinkActive="active">
  {{ text }}
</div>
